import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Empty } from "antd";
import { NotificationManager } from "react-notifications";
import KycOrdersTab from "./KycOrdersTab";
import { fetchOrderMasterList } from "./kycOrderShared";

const KycMaterialOrdersTab = ({ productName, search = "", isActive, navigationContext = {} }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [ordersTable, setOrdersTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [ordersSorter, setOrdersSorter] = useState({
		field: "createdOn",
		order: "DESC",
	});

	const loadOrdersList = useCallback(async () => {
		if (!productName) {
			setOrdersTable((prev) => ({ ...prev, rows: [], totalRecords: 0 }));
			return;
		}

		setIsLoading(true);
		try {
			const result = await fetchOrderMasterList({
				ispl_product: productName,
				search,
				pageindex: ordersTable.currentPage,
				pagesize: ordersTable.pageSize,
				sortcolumn: ordersSorter.field,
				orderBy: ordersSorter.order,
				groupCompanyId: navigationContext.groupCompanyId || "",
			});

			setOrdersTable((prev) => ({
				...prev,
				rows: result.rows,
				totalRecords: result.totalRecords,
				currentPage: result.currentPage,
			}));
		} catch (error) {
			console.log(error, "Error");
			NotificationManager.error("Unable to load orders listing.");
			setOrdersTable((prev) => ({ ...prev, rows: [], totalRecords: 0 }));
		} finally {
			setIsLoading(false);
		}
	}, [
		productName,
		search,
		ordersTable.currentPage,
		ordersTable.pageSize,
		ordersSorter.field,
		ordersSorter.order,
		navigationContext.groupCompanyId,
	]);

	useEffect(() => {
		if (!isActive || !productName) {
			return undefined;
		}
		loadOrdersList();
		return undefined;
	}, [isActive, productName, loadOrdersList]);

	useEffect(() => {
		if (!isActive) {
			return undefined;
		}
		setOrdersTable((prev) => ({ ...prev, currentPage: 1 }));
		return undefined;
	}, [search, isActive]);

	const handleOrdersTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setOrdersTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setOrdersSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const emptyText = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data found" />;

	const materialDetailsContext = useMemo(
		() => ({
			productName,
			materialName: navigationContext.materialName || productName,
			groupCompanyId: navigationContext.groupCompanyId || "",
			groupCompanyName: navigationContext.groupCompanyName || "",
			materialsCustomer: navigationContext.materialsCustomer || "",
			accountName: navigationContext.accountName || navigationContext.materialsCustomer || "",
			returnTab: navigationContext.returnTab || "materials",
		}),
		[productName, navigationContext]
	);

	return (
		<KycOrdersTab
			tabTableData={ordersTable}
			isLoading={isLoading}
			tableSorter={ordersSorter}
			OnhandleTableSortColumn={handleOrdersTableChange}
			materialDetailsContext={materialDetailsContext}
			emptyText={emptyText}
			tableSearchTerm={(search || "").trim()}
		/>
	);
};

export default KycMaterialOrdersTab;
